var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgR = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 6.315h4.242c.87 0 1.617.13 2.242.39.63.261 1.115.646 1.454 1.157.338.51.507 1.138.507 1.883 0 .61-.104 1.133-.312 1.57a2.94 2.94 0 0 1-.867 1.086c-.37.286-.805.516-1.305.687l-.742.391H9.53l-.015-1.828h2.742c.411 0 .752-.073 1.023-.219.271-.146.474-.349.61-.61.14-.26.21-.562.21-.905 0-.365-.067-.68-.203-.946a1.37 1.37 0 0 0-.617-.61c-.276-.14-.622-.21-1.039-.21h-1.898v9.539H8V6.315Zm6.36 11.375-2.594-5.07 2.476-.016 2.625 4.977v.109H14.36Z",
  fill: "#81BD5A"
})));
export default SvgR;